const ID = 'mk-replay-dogtag-store';

const TTL = 14_400_000; // 4 hours

export { ID, TTL };
